import {Component, EventEmitter, HostBinding, Input, Output, ViewChild} from '@angular/core';
import {RealTimeDetailComponent} from 'app/real-time/real-time-detail/real-time-detail.component';
import {groupBy} from 'app/common/utils';


@Component({
    selector: 'app-real-time-menu',
    templateUrl: './real-time-menu.component.html',
    styleUrls: ['./real-time-menu.component.scss']
})
export class RealTimeMenuComponent {
    private _showDetail = false;

    @Input() sources: any[];
    @Input() types: any[];
    @Input() mode: any = null;
    @Output() onToggleSource = new EventEmitter();

    public get showDetail() {
        return this._showDetail;
    };

    public set showDetail(show) {
        if (!show) {
            this.detailComponent.ngOnDestroy();
        }
        this._showDetail = show;
    }

    @HostBinding('class.opened') opened = false;
    @ViewChild('detail') detailComponent: RealTimeDetailComponent;

    constructor() {
    }

    closeDetail(e) {
        this.showDetail = false;
    }

    loadDetails(category, e) {
        this.showDetail = true;
        this.detailComponent.loadDetail(
            category,
            e.currentTarget.getElementsByTagName('h3')[0].textContent,
            this.mode
        );
    }

    toggleSource(source) {
        source.showing = !source.showing;
        this.onToggleSource.emit(source);
    }

    calculeElementsFromSource(src?) {
        let total = 0;
        (this.mode || {types: []}).types.forEach((type) => {
            const grouped = groupBy(type.data || [], 'source');
            if (src) {
                total += grouped[src] ? grouped[src].length : 0;
            } else {
                for (const _src_ of Object.keys(grouped)) {
                    total += grouped[_src_] ? grouped[_src_].length : 0;
                }
            }
        });
        return total;
    }

    toggleMenu() {
        this.opened = !this.opened;
    }

}



// WEBPACK FOOTER //
// ./src/app/real-time/real-time/real-time-menu/real-time-menu.component.ts